<template>
  <div>
    <v-card>
      <v-card-text>
        <h2>Ronda solar siguiente:</h2>
        <br />
        <h3>Futuras ramas:</h3>
        <div v-for="(cantidad, rama) in ramasNextYear" :key="rama">
          <b>{{ rama }}: </b> {{ cantidad }}
        </div>
        <br />
        <h3>Futuro año:</h3>
        <div v-for="(cantidad, year) in peopleByYearBorn" :key="year">
          <b>{{ year }}: </b> {{ cantidad }}
          <v-progress-linear
            :value="(cantidad / 100) * 100"
            color="green"
            background-color="white"
          ></v-progress-linear>
        </div>
      </v-card-text>
      <hr />

      {{ peopleByYearBorn }}
    </v-card>
  </div>
</template>

<script>
export default {
  name: "persons",
  data() {
    return {
      inscriptionData: [],
      peopleData: [],
    };
  },
  created() {
    this.datos = 0;
    //Get inscription data
    let out = this.$db
      .collection("forms")
      .doc("inscripciones")
      .collection("answers")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          //Remove property "" from object, property causes error at add to object becouse is a reference

          let bulkInscriptionData = doc.data();

          let tempPepleArray = [];

          for (let inscription of bulkInscriptionData.people) {
            tempPepleArray.push({
              personId: inscription.id,
              personPath: inscription.path,
            });
          }
          bulkInscriptionData["people"] = tempPepleArray;

          //Change "booking" to string, due to error when add to an object
          /*
          bulkInscriptionData["bookingId"] = bulkInscriptionData.booking.id;
          bulkInscriptionData["bookingPath"] = bulkInscriptionData.booking.path;
          delete bulkInscriptionData.booking;
          */

          let inscription = new Object();
          Object.keys(bulkInscriptionData).forEach(
            (
              key //console.log(bulkInscriptionData)
            ) => (inscription[key] = bulkInscriptionData[key])
          );
          this.inscriptionData.push(inscription);
        });
      })
      .catch((err) => {
        console.log("Error getting documents", err);
      });

    //Get person data
    let people = this.$db
      .collection("forms")
      .doc("inscripciones")
      .collection("people")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          //Remove property "" from object, property causes error at add to object becouse is a reference

          let bulkPersonData = doc.data();

          //Change "booking" to string, due to error when add to an object
          bulkPersonData["bookingId"] = bulkPersonData.booking.id;
          bulkPersonData["bookingPath"] = bulkPersonData.booking.path;
          delete bulkPersonData.booking;
          let persona = new Object();
          Object.keys(bulkPersonData).forEach(
            (key) => (persona[key] = bulkPersonData[key])
          );
          this.peopleData.push(persona);
        });
      })
      .catch((err) => {
        console.log("Error getting documents", err);
      });

    //Now we have all the data, make the calculus
  },
  computed: {
    //Computed functions are triggered only when there is a change in data

    //Return array of year:number of persons
    peopleByYearBorn() {
      //YearList = ['2001,'2001,'2003',...]
      let yearsList = this.peopleData.map((persona) =>
        persona.birthday.slice(0, 4)
      );

      //Remove too old and too young people
      let thisYear = new Date().getFullYear();
      let peopleByYearBounded = yearsList
        .map(function (year) {
          if (
            parseInt(year) >= thisYear - 18 &&
            parseInt(year) <= thisYear - 8
          ) {
            return year;
          } else {
            return null; //Return null to remove in filter
          }
        })
        .filter((year) => year != null);

      //PeopleByYear =  array of year:number of persons
      let peopleByYear = {};
      peopleByYearBounded.forEach(function (x) {
        peopleByYear[x] = (peopleByYear[x] || 0) + 1;
      });

      return peopleByYear;
    },
    //Return comuna: 24, clan: 17, ...
    ramasNextYear() {
      let thisYear = new Date().getFullYear();

      //If now is 2021, next year of COMUNA is 2003, so 18 from this year

      return {
        //Ternary needed becouse on start no data found

        //Castores needs ternary operator due to undefined.toString
        Castores:
          (this.peopleByYearBorn[thisYear - 8]
            ? this.peopleByYearBorn[thisYear - 8].toString()
            : 0) + " + ¿?",
        Lobatos:
          (this.peopleByYearBorn[thisYear - 11]
            ? this.peopleByYearBorn[thisYear - 11]
            : 0) +
          (this.peopleByYearBorn[thisYear - 10]
            ? this.peopleByYearBorn[thisYear - 10]
            : 0) +
          (this.peopleByYearBorn[thisYear - 9]
            ? this.peopleByYearBorn[thisYear - 9]
            : 0),
        Tropa:
          (this.peopleByYearBorn[thisYear - 14]
            ? this.peopleByYearBorn[thisYear - 14]
            : 0) +
          (this.peopleByYearBorn[thisYear - 13]
            ? this.peopleByYearBorn[thisYear - 13]
            : 0) +
          (this.peopleByYearBorn[thisYear - 12]
            ? this.peopleByYearBorn[thisYear - 12]
            : 0),
        Escultas:
          (this.peopleByYearBorn[thisYear - 16]
            ? this.peopleByYearBorn[thisYear - 16]
            : 0) +
          (this.peopleByYearBorn[thisYear - 15]
            ? this.peopleByYearBorn[thisYear - 15]
            : 0),
        Clan: this.peopleByYearBorn[thisYear - 17]
          ? this.peopleByYearBorn[thisYear - 17]
          : 0,
        Comuna: this.peopleByYearBorn[thisYear - 18]
          ? this.peopleByYearBorn[thisYear - 18]
          : 0,
      };

      console.log(this.peopleByYearBorn);
      console.log(this.peopleByYearBorn[thisYear - 18]);

      return this.peopleByYearBorn[thisYear];
    },
  },
};
</script>

<style scoped>
</style>